import { ChevronDown, CircleHelp } from 'lucide-react'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible'
import { cn } from '@/shared/lib/utils'

type BriefingGuidanceCollapsibleProps = {
  title: string
  intro: string
  items: string[]
  idPrefix: string
  className?: string
}

export function BriefingGuidanceCollapsible({
  title,
  intro,
  items,
  idPrefix,
  className,
}: BriefingGuidanceCollapsibleProps) {
  return (
    <Collapsible
      defaultOpen={false}
      className={cn(
        'w-full overflow-hidden rounded-lg border border-border bg-muted/40 text-foreground',
        className
      )}
    >
      <CollapsibleTrigger className='flex w-full items-center gap-2 px-3 py-2.5 text-start hover:bg-muted/60'>
        <CircleHelp
          className='size-4 shrink-0 text-muted-foreground'
          aria-hidden
        />
        <span className='min-w-0 flex-1 text-xs font-medium'>{title}</span>
        <ChevronDown
          className='size-4 shrink-0 text-muted-foreground transition-transform duration-200 in-data-panel-open:rotate-180'
          aria-hidden
        />
      </CollapsibleTrigger>
      <CollapsibleContent className='border-t border-border'>
        <div className='space-y-1.5 px-3 py-2.5'>
          <p className='text-xs text-muted-foreground'>{intro}</p>
          {items.length > 0 ? (
            <ul className='list-disc space-y-0.5 ps-4 text-xs text-muted-foreground'>
              {items.map((item, itemIndex) => (
                <li key={`${idPrefix}-${itemIndex}`}>{item}</li>
              ))}
            </ul>
          ) : null}
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}
